import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { ExclamationCircleFill } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import FormBox from "../../../components/FormBox/FormBox";
import { achInfoFormSchema, taxFormArr } from "../../../Utils/formOptions";
import { LoadingButton } from "../../../Utils/CustomComponent";
import axiosInstance from "../../../axios";
import urls from "../../../Utils/urls";
import { useSelector } from "react-redux";
import useBorowerLoanDetail from "../../../hooks/useBorowerLoanDetail";
import { loadingTypes, oracleConfig } from "../../../Utils/constant";
import moment from "moment";
import { useAbortController } from "../../../hooks/useAbortController";
import { RoutingNumberValidator } from "../Pages/ACHPayments/SameDayPayment";
import useAchData from "../BankAccountACHPayments/useAchData";
import { toast } from "react-toastify";
import { commonToast } from "../../../Utils";

const AchPopup = () => {
  const [showTaxInfo, setShowTaxInfo] = useState(false);
  const [showTaxForm, setShowTaxForm] = useState(false);
  const [showAchSetup, setShowAchSetup] = useState(false);

  return (
    <div>
      <div className="p-4">
        <div className="p-4">
          <button
            className="btn btn-primary"
            onClick={() => setShowTaxInfo(true)}
          >
            Submit Tax Information
          </button>
          <button
            className="btn btn-primary mt-3"
            onClick={() => setShowAchSetup(true)}
          >
            Set Up ACH Payments
          </button>
        </div>
      </div>

      <TaxInfoModal
        show={showTaxInfo}
        setShow={setShowTaxInfo}
        setShowTaxForm={setShowTaxForm}
      />
      <TaxFormModal
        show={showTaxForm}
        setShow={setShowTaxForm}
        setShowTaxInfo={setShowTaxInfo}
      />
      <AchSetupModal show={showAchSetup} setShow={setShowAchSetup} />
    </div>
  );
};

export const TaxInfoModal = ({
  show,
  setShow,
  setShowAchAlert,
  achCondition = false,
  loanRecId = null,
  setRefresh = null,
}) => {
  const [disableBtn, setDisableBtn] = useState(false);
  const loanId = useSelector((state) => state.account.lenderId);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm(taxFormArr);

  const SSN = watch("form_SSN");
  const EIN = watch("form_EIN");

  async function onSubmit(data) {
    setDisableBtn(true);
    try {
      const data = {
        LoanRecID: loanRecId ? loanRecId : loanId,
        DBName: selectedAccount?.databasename,
        TINType: EIN ? 1 : 2,
        EIN: EIN ? EIN : "",
        SSN: SSN ? SSN : "",
      };

      const res = await axiosInstance.post(urls.borrower.submitTaxInfo, data);

      if (res.status == 200) {
        const res2 = await axiosInstance.post(
          urls.borrower.borrowerTaxInfoOracle,
          data,
          oracleConfig
        );
        if (res2.status == "200") {
          setShow(false);
          toast.success("Tax info submitted successfully", {
            ...commonToast,
          });
          if (achCondition) {
            setShowAchAlert(true);
          } else if (!achCondition && setRefresh !== null) {
            setRefresh(true);
          }
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Some error occured", {
        ...commonToast,
      });
    } finally {
      setDisableBtn(false);
    }
  }

  return (
    <Modal show={show} onHide={() => setShow(false)} centered backdrop="static">
      <Modal.Header
      // closeButton
      >
        <Modal.Title style={{ paddingLeft: "10px" }}>
          Submit Tax Information
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="" style={{ margin: "0 auto" }}>
          <div
            className="mb-4 py-5"
            style={{
              border: "1px solid #dee2e6",
              borderRadius: "0.375rem",
            }}
          >
            <FormBox
              options={taxArr}
              register={register}
              watch={watch}
              setValue={setValue}
              errors={errors}
            />
            {errors?.[""] ? (
              <div className="invalid-feedback d-block mt-3">
                {errors?.[""].message}
              </div>
            ) : null}
            {/* <div className="mb-4">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your name"
              />
            </div>
            <div className="mb-4">
              <label className="form-label">
                Taxpayer Identification Number (TIN)
              </label>
              <p className="text-muted">
                The TIN provided must match the name above.
              </p>
              <div className="mb-3">
                <label>Social Security Number</label>
                <div className="d-flex gap-2">
                  <input type="text" className="form-control" maxLength="3" />
                  <input type="text" className="form-control" maxLength="2" />
                  <input type="text" className="form-control" maxLength="4" />
                </div>
              </div>
              <div className="text-center my-4">
                <span className="px-3">or</span>
              </div>
              <div>
                <label>Employer Identification Number</label>
                <input type="text" className="form-control" />
              </div>
            </div> */}
          </div>
          <LoadingButton
            // style={{ backgroundColor: "#343a40", borderColor: "#343a40" }}
            onClick={handleSubmit(onSubmit)}
            type="button"
            className="btn btn-primary my-3 w-100 text-white"
            title={"Submit"}
            disabled={disableBtn}
            loading={disableBtn}
          >
            Submit
          </LoadingButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const TaxFormModal = ({ show, setShow, setShowTaxInfo }) => {
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="md"
      centered
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>Tax Information Required</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-5">
        <div className="p-4">
          {/* Add tax form fields here */}
          <div className="d-flex gap-3">
            <div>
              <ExclamationCircleFill size={22} color="var(--primary-color)" />
            </div>
            <h5> Submit Tax Information</h5>
          </div>
          <p>Tax information has not been submitted.</p>
          <button
            className="btn btn-primary w-50"
            onClick={() => {
              setShowTaxInfo(true);
              setShow(false);
            }}
          >
            Submit Tax Form
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const AchAlertModal = ({ show, setShow, setShowAchSetup }) => {
  const [checked, setChecked] = useState(false);

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="md"
      centered
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>ACH Information Required</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-5">
        <div>
          <div className="border">
            <div className="alert alert-yellow p-5" role="alert">
              <div className="d-flex align-items-center gap-3 mb-3">
                <div>
                  <ExclamationCircleFill
                    size={20}
                    color="var(--primary-color)"
                  />
                </div>
                <h5> ACH payments are not set up</h5>
              </div>
              <p className="px-5">
                I do not want to setup ACH payments at this time.
              </p>
            </div>
            <div className="p-4 px-5">
              <div className="form-group">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="achForm"
                    checked={checked}
                    onChange={(e) => {
                      setChecked(e.target.checked);
                    }}
                  />
                  <label className="form-check-label" htmlFor="achForm">
                    I do not want to setup ACH payments at this time.
                  </label>
                </div>
              </div>

              <button
                className="btn btn-primary w-50 mt-5"
                onClick={() => setShowAchSetup(true)}
              >
                Set Up ACH Payments
              </button>
            </div>
          </div>
          <button
            className="btn btn-primary mt-5 w-100"
            disabled={!checked}
            onClick={() => {
              setShow(false);
              sessionStorage.setItem("achAlert", false);
            }}
          >
            Continue
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const AchSetupModal = ({ show, setShow, setRefresh = null }) => {
  const [disableBtn, setDisableBtn] = useState(false);
  const [isRoutingNumberVerified, setIsRoutingNumberVerified] = useState(false);
  const [showRoutingNumberVaildatorPopup, setShowRoutingNumberVaildatorPopup] =
    useState(false);
  const [disableLoading, setDisableLoading] = useState(false);

  const loanId = useSelector((state) => state.account.lenderId);
  const { loanDetails, status } = useBorowerLoanDetail(loanId);
  const { fetchACHData, achData, loading } = useAchData();
  // Using all required React Hook Form functions
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    setError,
    clearErrors,
    control,
  } = useForm(achInfoFormSchema);
  const { signal } = useAbortController();

  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  const routingNumber = watch("routingNumber");

  useEffect(() => {
    if (loanId) {
      fetchACHData(loanId);
    }
  }, [loanId]);

  useEffect(() => {
    if (status === loadingTypes.fulfilled && !loading) {
      setValue("borrowerName", loanDetails?.borrowOverview?.["Borrower Name"]);
      setValue("loanId", loanDetails?.borrowOverview?.["Account Number"]);
      setValue(
        "propertyAddress",
        loanDetails?.loanTerm?.loanheader2?.split(":")[1]
      );

      setValue("bankName", achData?.[0]?.ACH_IndividualName);
      setValue("accountNumber", achData?.[0]?.ACH_AccountNumber);
      setValue("debitAmount", achData?.[0]?.ACH_DebitAmount);
      setValue("debitDay", achData?.[0]?.ACH_DebitDueDay);
      setValue("routingNumber", achData?.[0]?.ACH_RoutingNumber);
      setValue("accountType", achData?.[0]?.ACH_AccountType);
    }
  }, [status, loading]);

  useEffect(() => {
    const handleRoutingNumberValidation = async () => {
      try {
        setDisableLoading(true);
        const getData = await axiosInstance.get(
          urls.borrower.getRoutingNumberValidation(routingNumber),
          { signal }
        );

        if (getData?.data.code == 404) {
          setError("routingNumber", {
            type: "custom",
            message: "Invalid routing number",
          });
          setShowRoutingNumberVaildatorPopup(true);
          setIsRoutingNumberVerified(false);

          // setDisableLoading(true);
        } else if (getData?.data.code == 200) {
          setIsRoutingNumberVerified(true);
          setDisableLoading(false);
          clearErrors("routingNumber");
        }
        return getData.data;
      } catch (error) {
        setError("routingNumber", {
          type: "custom",
          message: "Routing validation failed",
        });

        setDisableLoading(true);
      }
    };
    if (routingNumber?.length === 9) {
      handleRoutingNumberValidation();
    } else if (routingNumber?.length && routingNumber?.length !== 9) {
      setError("routingNumber", {
        type: "custom",
        message: "Routing number must be 9 digits",
      });

      setDisableLoading(true);
    }
  }, [routingNumber]);

  // Handle form submission
  const onSubmit = async (data) => {
    // console.log(data)
    setDisableBtn(true);

    try {
      const res = await axiosInstance.post(
        urls.borrower.postPaymentsLoanAchInfoUAT,
        [
          {
            loanID: loanId,
            ACH_RoutingNumber: data.routingNumber,
            ACH_AccountType: data.accountType,
            ACH_AccountNumber: data.accountNumber,
            ACH_Frequency: Number(achData?.[0]?.ACH_Frequency),
            ACH_DebitAmount: data.debitAmount,
            ACH_ServiceStatus: Number(achData?.[0]?.ACH_ServiceStatus),
            ACH_StopDate: moment(achData?.[0]?.ACH_StopDate).format(
              "MM/DD/YYYY"
            ),
            ACH_DebitDueDay: Number(data.debitDay),
            ACH_NextPaymentDate: moment(data.startDate).format("MM/DD/YYYY"),
            ACH_IndividualName: data.bankName,
            // email: achInfo.emailaddress,
            email: userDetails?.email,
            early_payment_type: "RP",
            early_payment_note: "",
            isRoutingNumberVerified: isRoutingNumberVerified,
          },
        ],
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          },
        }
      );

      toast.success("Success!", {
        ...commonToast,
      });

      if (setRefresh !== null) {
        setRefresh(true);
      }
    } catch (error) {
      console.error(error);
      toast.error("Upload Failed", {
        ...commonToast,
      });
    } finally {
      setShow(false); // Close the modal after submission
      setDisableBtn(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      backdrop="static"
      size="lg"
    >
      <Modal.Header>
        <Modal.Title
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
            paddingLeft: "10px",
          }}
        >
          ACH Direct Debit Setup
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-4" style={{ margin: "0 auto" }}>
          {/* Borrower Information Section */}
          <div
            className="mb-4 row"
            style={{
              border: "1px solid #dee2e6",
              borderRadius: "0.375rem",
              padding: "20px",
            }}
          >
            <h5 className="mb-3">Borrower Information</h5>
            <div className="mb-3 col-6">
              <label className="form-label">Borrower Name</label>
              <input
                type="text"
                className="form-control"
                {...register("borrowerName")}
                readOnly={true}
              />
            </div>
            <div className="mb-3 col-6">
              <label className="form-label">Loan ID Number</label>
              <input
                type="text"
                className="form-control"
                {...register("loanId")}
                readOnly={true}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Property Address</label>
              <input
                type="text"
                className="form-control"
                {...register("propertyAddress")}
                readOnly={true}
              />
            </div>
          </div>

          {/* Banking Account Information Section */}
          <div
            className="mb-4 row"
            style={{
              border: "1px solid #dee2e6",
              borderRadius: "0.375rem",
              padding: "5px",
            }}
          >
            <h5 className="mb-3">Banking Account Information</h5>
            <FormBox
              options={achFormArr(control)}
              register={register}
              watch={watch}
              setValue={setValue}
              errors={errors}
            />

            {/* <div className="mb-3">
              <label className="form-label">Bank Account Type</label>
              <select className="form-select" {...register("accountType")}>
                <option value="checking">Checking</option>
                <option value="savings">Savings</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Bank Name</label>
              <input
                type="text"
                className="form-control"
                {...register("bankName")}
              />
            </div>
            <div className="mb-3 col-6">
              <label className="form-label">Routing Number</label>
              <input
                type="text"
                className="form-control"
                {...register("routingNumber")}
              />
            </div>
            <div className="mb-3 col-6">
              <label className="form-label">Account Number</label>
              <input
                type="text"
                className="form-control"
                {...register("accountNumber")}
              />
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Debit Amount</label>
                <div className="input-group">
                  <span className="input-group-text">$</span>
                  <input
                    type="number"
                    className="form-control"
                    {...register("debitAmount")}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label">Schedule Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="MM/DD/YYYY"
                  {...register("startDate")}
                />
              </div>
            </div>

            <div className="row mb-3 col-md-6">
              <div className="col-md-6">
                <label className="form-label">Schedule Start</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("scheduleStart")}
                />
              </div>
              <div className="">
                <label className="form-label">ACH Debit Day</label>
                <select className="form-select" {...register("debitDay")}>
                  {Array.from({ length: 28 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Bank Account Type</label>
              <select className="form-select" {...register("accountType")}>
                <option value="checking">Checking</option>
                <option value="savings">Savings</option>
              </select>
            </div> */}
          </div>

          <LoadingButton
            // style={{ backgroundColor: "#343a40", borderColor: "#343a40" }}
            onClick={handleSubmit(onSubmit)}
            type="button"
            className="btn btn-primary my-3 w-100 text-white"
            title={"Submit"}
            disabled={disableBtn || disableLoading}
            loading={disableBtn}
          >
            Submit
          </LoadingButton>
        </div>
      </Modal.Body>
      <RoutingNumberValidator
        show={showRoutingNumberVaildatorPopup}
        setShow={setShowRoutingNumberVaildatorPopup}
        clearErrors={clearErrors}
        setDisableBtn={setDisableLoading}
        routingNumber={routingNumber}
      />
    </Modal>
  );
};

export default AchPopup;

const taxArr = [
  {
    content: "Account Name",
    type: "content",
    className: "col-12",
  },
  {
    title: "Enter your account name",
    field: "sortName",
    type: "text",
    className: "col-12",
  },
  {
    content: (
      <div>
        <label className="form-label">
          Taxpayer Identification Number (TIN)
        </label>
        <p className="text-muted">
          The TIN provided must match the name above.
        </p>
      </div>
    ),
    type: "content",
    className: "col-12",
  },
  {
    title: "Social Security Number",
    field: "form_SSN",
    type: "otp",
    length: 9,
    pattern: "123-45-6789",
    className: "col-12",
  },
  {
    content: <div className="text-center">or</div>,
    type: "content",
    className: "col-12",
  },
  {
    title: "Employer Identification Number",
    field: "form_EIN",
    type: "otp",
    length: 9,
    pattern: "12-3456789",
    className: "col-12",
  },
];

const achFormArr = (control) => [
  {
    title: "Bank Account Name",
    field: "bankName",
    type: "text",
    className: "col-12",
  },
  {
    title: "Routing Number",
    field: "routingNumber",
    type: "number",
    className: "col-6",
  },
  {
    title: "Account Number",
    field: "accountNumber",
    type: "number",
    className: "col-6",
    // eyeIcon: true,
  },
  {
    title: "Debit Amount",
    field: "debitAmount",
    type: "amount",
    className: "col-6",
    control: control,
  },
  {
    title: "Schedule Start Date",
    field: "startDate",
    type: "date",
    minDate: new Date(moment().add(1, "days")),
    defaultValue: new Date(moment().add(1, "days")),
    className: "col-6",
    filter: true,
  },
  {
    title: "ACH Debit Day",
    field: "debitDay",
    type: "select",
    options: Array.from({ length: 28 }, (_, i) => ({
      label: `${i + 1}`,
      value: `${i + 1}`,
    })),
    defaultValue: "1",
    className: "col-6",
  },
  {
    title: "Bank Account Type",
    field: "accountType",
    type: "select",
    options: [
      { label: "Checking", value: "0" },
      { label: "Savings", value: "1" },
    ],
    className: "col-6",
    defaultValue: "0",
  },
];
